var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportGeon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 59",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 31,
    y: 32,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 32,
    width: 32,
    height: 32,
    id: "mask0_15822_112681_00000164502335907257878160000011892646399184828849_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7 44v-5.3L59 48l-9.3 9.3v-5.5C43 51.9 38.3 54 35 58.7 36.3 52 40.3 45.3 49.7 44z",
    style: {
      fill: "#fff",
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31 32h32v32H31z",
    style: {
      mask: "url(#mask0_15822_112681_00000164502335907257878160000011892646399184828849_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28 4H12C9.8 4 8 5.8 8 8v32c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V16L28 4zM12 40V8h14v10h10v22H12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportGeon);
export default __webpack_public_path__ + "static/media/import-geon.d170d47bdffb299751dfb72a6875290a.svg";
export { ForwardRef as ReactComponent };